export const MONTHS = ['Jan', 'Feb', 'Mar', 'apr', 'may', 'jun', 'aug', 'sep', 'oct', 'nov', 'dec']
export const FILE_ACCEPT = ["image/jpeg", "image/png", "image/jpg"];
export const INVALID_FILE_FORMAT_ERROR_MESSAGE = "Invalid file format. Please upload an image file."
export const FILE_SIZE_ERROR = "File upload of more than 5MB is not allowed"

export const MAX_FILE_SIZE = 5

export const vendorTypeOptions=[
   {label:"Vendor",value:"Vendor"},
   {label:"Sub-Contractor",value:"Sub-Contractor"},
 ]